export default function rStatus(){
    return(
         [
            { code: "RES", description: "Resident" },
            { code: "NOR", description: "Resident But Not Ordinarily Resident" },
            { code: "NR", description: "Non Resident" }
          ]
    )
}